import C from '../constants';


import Pusher from 'pusher-js';
// Put 'pusher' on global window for TypeScript validation
declare global {
  interface Window { pusher: any }
}

import _ from 'underscore';
import { requestPost, } from '../../../modules/request/index';
import lessonActions from '../actions/lessons';
import { Question } from '../interfaces/questions';
import { LessonApi, TYPE_CONNECT_LESSON } from '../libs/lessons_api';
import {
  FocusPointApi,
  IncorrectSequenceApi,
  QuestionApi,
  SENTENCE_COMBINING_TYPE
} from '../libs/questions_api';
import { saveResponseToCMS } from './responses';

function startListeningToQuestions() {
  return loadQuestions();
}

function loadQuestions() {
  return (dispatch, getState) => {
    QuestionApi.getAll(SENTENCE_COMBINING_TYPE).then((questions) => {
      dispatch({ type: C.RECEIVE_QUESTIONS_DATA, data: questions, });
    });
  };
}

function loadQuestion(uid) {
  return (dispatch, getState) => {
    QuestionApi.get(uid).then((question: Question) => {
      dispatch({ type: C.RECEIVE_QUESTION_DATA, uid: uid, data: question, });
    });
  }
}

function startQuestionEdit(qid) {
  return { type: C.START_QUESTION_EDIT, qid, };
}

function cancelQuestionEdit(qid) {
  return { type: C.FINISH_QUESTION_EDIT, qid, };
}

function submitQuestionEdit(qid, content) {
  return (dispatch, getState) => {
    dispatch({ type: C.SUBMIT_QUESTION_EDIT, qid, });
    QuestionApi.update(qid, content).then(() => {
      dispatch({ type: C.FINISH_QUESTION_EDIT, qid, });
      dispatch(loadQuestion(qid));
      dispatch({ type: C.DISPLAY_MESSAGE, message: 'Update successfully saved!', });
    }).catch((error) => {
      dispatch({ type: C.FINISH_QUESTION_EDIT, qid, });
      dispatch({ type: C.DISPLAY_ERROR, error: `Update failed! ${error}`, });
    });
  };
}

function toggleNewQuestionModal() {
  return { type: C.TOGGLE_NEW_QUESTION_MODAL, };
}

function submitNewQuestion(content, response, lessonID) {
  return (dispatch, getState) => {
    dispatch({ type: C.AWAIT_NEW_QUESTION_RESPONSE, });
    QuestionApi.create(SENTENCE_COMBINING_TYPE, content).then((question) => {
      dispatch({ type: C.RECEIVE_NEW_QUESTION_RESPONSE, });
      response.questionUID = Object.keys(question)[0];
      response.gradeIndex = `human${response.questionUID}`;
      dispatch(saveResponseToCMS(response));
      dispatch(loadQuestion(response.questionUID));
      dispatch({ type: C.DISPLAY_MESSAGE, message: 'Submission successfully saved!', });
      const lessonQuestion = { key: response.questionUID, questionType: C.INTERNAL_SENTENCE_COMBINING_TYPE }
      dispatch({ type: C.SUBMIT_LESSON_EDIT, cid: lessonID, });
      LessonApi.addQuestion(TYPE_CONNECT_LESSON, lessonID, lessonQuestion).then(() => {
        dispatch({ type: C.FINISH_LESSON_EDIT, cid: lessonID, });
        dispatch(lessonActions.loadLesson(lessonID));
        dispatch({ type: C.DISPLAY_MESSAGE, message: 'Question successfully added to lesson!', });
      }).catch((error) => {
        dispatch({ type: C.FINISH_LESSON_EDIT, cid: lessonID, });
        dispatch({ type: C.DISPLAY_ERROR, error: `Add to lesson failed! ${error}`, });
      });
    }, (error) => {
      dispatch({ type: C.RECEIVE_NEW_QUESTION_RESPONSE, });
      dispatch({ type: C.DISPLAY_ERROR, error: `Submission failed! ${error}`, });
    });
  };
}

function submitNewFocusPoint(qid, data, callback) {
  return (dispatch, getState) => {
    FocusPointApi.create(qid, data).then(() => {
      dispatch(loadQuestion(qid));
      if (callback) callback();
    }, (error) => {
      alert(`Submission failed! ${error}`);
    });
  }
}

function submitEditedFocusPoint(qid, data, fpid) {
  return (dispatch, getState) => {
    FocusPointApi.update(qid, fpid, data).then(() => {
      dispatch(loadQuestion(qid));
    }).catch((error) => {
      alert(`Submission failed! ${error}`);
    });
  };
}

function submitBatchEditedFocusPoint(qid, data, callback) {
  return (dispatch, getState) => {
    FocusPointApi.updateAllForQuestion(qid, data).then(() => {
      dispatch(loadQuestion(qid));
      if (callback) callback();
    }).catch((error) => {
      alert(`Submission failed! ${error}`);
    });
  };
}

function deleteFocusPoint(qid, fpid) {
  return (dispatch, getState) => {
    FocusPointApi.remove(qid, fpid).then(() => {
      dispatch(loadQuestion(qid));
    }, (error) => {
      alert(`Delete failed! ${error}`);
    });
  };
}

//TODO: fix error handling for updateFlag-- causes many alert messages to flash despite successful update

function updateFlag(qid, flag) {
  return dispatch => {
    QuestionApi.updateFlag(qid, flag).then(() => {
      dispatch(loadQuestion(qid));
    }).catch((error) => {
      alert(`Flag update failed! ${error}`);
    });
  }
}

function updateModelConceptUID(qid, modelConceptUID) {
  return dispatch => {
    QuestionApi.get(qid).then((question) => {
      if (!question.modelConceptUID) {
        QuestionApi.updateModelConcept(qid, modelConceptUID).then(() => {
          dispatch(loadQuestion(qid));
        }).catch((error) => {
          alert(`Model concept update failed! ${error}`);
        });
      }
    });
  }
}

function submitNewIncorrectSequence(qid, data, callback) {
  return (dispatch, getState) => {
    IncorrectSequenceApi.create(qid, data).then(() => {
      dispatch(loadQuestion(qid));
      callback();
    }, (error) => {
      alert(`Submission failed! ${error}`);
    });
  };
}

function submitEditedIncorrectSequence(qid, data, seqid) {
  return (dispatch, getState) => {
    IncorrectSequenceApi.update(qid, seqid, data).then(() => {
      dispatch(loadQuestion(qid));
    }).catch((error) => {
      alert(`Submission failed! ${error}`);
    });
  };
}

function deleteIncorrectSequence(qid, seqid) {
  return (dispatch, getState) => {
    IncorrectSequenceApi.remove(qid, seqid).then(() => {
      dispatch(loadQuestion(qid));
    }, (error) => {
      alert(`Delete failed! ${error}`);
    });
  };
}

function updateIncorrectSequences(qid, data, callback) {
  return (dispatch, getState) => {
    IncorrectSequenceApi.updateAllForQuestion(qid, data).then(() => {
      dispatch(loadQuestion(qid));
      callback();
    }).catch((error) => {
      alert(`Order update failed! ${error}`);
    });
  }
}

function getFormattedSearchData(state) {
  const searchData = state.filters.formattedFilterData;
  searchData.text = state.filters.stringFilter;
  searchData.pageNumber = state.filters.responsePageNumber;
  return searchData;
}

function searchResponses(qid, callback) {
  return (dispatch, getState) => {
    const requestNumber = getState().filters.requestCount
    // check for request number in state, save as const
    requestPost(
      `${window.postbuildEnv.QUILL_CMS}/questions/${qid}/responses/search`,
      { search: getFormattedSearchData(getState()), },
      (data) => {
        // check again for number in state
        // if equal to const set earlier, update the state
        // otherwise, do nothing
        if (getState().filters.requestCount === requestNumber) {
          const embeddedOrder = _.map(data.results, (response: any, i: number) => {
            response.sortOrder = i;
            return response;
          });
          const parsedResponses = _.indexBy(embeddedOrder, 'id');
          const responseData = {
            responses: parsedResponses,
            numberOfResponses: data.numberOfResults,
            numberOfPages: data.numberOfPages,
          };
          dispatch(updateResponses(responseData));
          callback();
        }
      }
    );
  };
}

function initializeSubscription(qid) {
  return (dispatch) => {
    if (window.postbuildEnv.NODE_ENV === 'development') {
      Pusher.logToConsole = true;
    }
    if (!window.pusher) {
      window.pusher = new Pusher(window.postbuildEnv.PUSHER_KEY, { cluster: window.postbuildEnv.PUSHER_CLUSTER });
    }
    const channel = window.pusher.subscribe(`admin-${qid}`);
    channel.bind('new-response', (data) => {
      setTimeout(() => dispatch(searchResponses(qid)), 1000);
    });
    channel.bind('rematching-finished', () => {
      window.alert(`Rematching finished for the Connect question with uid ${qid}! Reload the page to see the rematched responses.`)
    })
  };
}

function removeSubscription(qid) {
  return (dispatch) => {
    if (window.pusher) {
      window.pusher.unsubscribe(`admin-${qid}`);
    }
  };
}

function updatePageNumber(pageNumber) {
  return (dispatch) => {
    dispatch(setPageNumber(pageNumber));
  };
}

function updateStringFilter(stringFilter) {
  return (dispatch) => {
    dispatch(setStringFilter(stringFilter));
  };
}

function getUsedSequences(qid) {
  return (dispatch, getState) => {
    const existingIncorrectSeqs = getState().questions.data[qid].incorrectSequences
    const usedSeqs: string[] = []
    if (existingIncorrectSeqs) {
      Object.values(existingIncorrectSeqs).forEach((inSeq: any) => {
        const phrases = inSeq.text.split('|||')
        phrases.forEach((p) => {
          usedSeqs.push(p)
        })
      })
    }
    dispatch(setUsedSequences(qid, usedSeqs));
  }
}

function setUsedSequences(qid, seq) {
  return { type: C.SET_USED_SEQUENCES, qid, seq }
}

function startResponseEdit(qid, rid) {
  return { type: C.START_RESPONSE_EDIT, qid, rid, };
}

function cancelResponseEdit(qid, rid) {
  return { type: C.FINISH_RESPONSE_EDIT, qid, rid, };
}

function clearQuestionState(qid) {
  return { type: C.CLEAR_QUESTION_STATE, qid, };
}

function updateResponses(data) {
  return { type: C.UPDATE_SEARCHED_RESPONSES, data, };
}

function setPageNumber(pageNumber) {
  return { type: C.SET_RESPONSE_PAGE_NUMBER, pageNumber, };
}

function setStringFilter(stringFilter) {
  return { type: C.SET_RESPONSE_STRING_FILTER, stringFilter, };
}

function incrementRequestCount() {
  return { type: C.INCREMENT_REQUEST_COUNT }
}

export default {
  startListeningToQuestions,
  loadQuestions,
  loadQuestion,
  startQuestionEdit,
  cancelQuestionEdit,
  submitQuestionEdit,
  toggleNewQuestionModal,
  submitNewQuestion,
  submitNewFocusPoint,
  submitEditedFocusPoint,
  submitBatchEditedFocusPoint,
  deleteFocusPoint,
  submitNewIncorrectSequence,
  submitEditedIncorrectSequence,
  deleteIncorrectSequence,
  updateIncorrectSequences,
  searchResponses,
  initializeSubscription,
  removeSubscription,
  updatePageNumber,
  updateStringFilter,
  startResponseEdit,
  cancelResponseEdit,
  clearQuestionState,
  updateResponses,
  setPageNumber,
  setStringFilter,
  incrementRequestCount,
  updateFlag,
  getUsedSequences,
  updateModelConceptUID
};
